export function findYExtremes(data) {
    let smallestY = null;
    let greatestY = null;
    for (let i = 0; i < data.length; i += 1) {
        const d = data[i];
        if (d.y !== undefined && (smallestY === null || d.y < smallestY.y)) {
            smallestY = { x: d.x, y: d.y };
        }
        if (d.y !== undefined && (greatestY === null || d.y > greatestY.y)) {
            greatestY = { x: d.x, y: d.y };
        }
    }
    return {
        greatestY: greatestY === null ? { x: data[0].x, y: 1 } : greatestY,
        smallestY: smallestY === null ? { x: data[data.length - 1].x, y: -1 } : smallestY,
    };
}
export const parse = (data, yRange) => {
    const { greatestY, smallestY } = findYExtremes(data);
    const minY = yRange ? yRange[0] : smallestY.y;
    const maxY = yRange ? yRange[1] : greatestY.y;
    const smallestX = data[0];
    const greatestX = data[data.length - 1];
    const parsedOriginalData = [];
    const parsedOriginalDataNullable = [];
    for (let i = 0; i < data.length; i += 1) {
        const d = data[i];
        if (d.y !== undefined) {
            const dataPoint = {
                ...d,
                originalX: d.x,
                originalY: d.y,
                x: (d.x - smallestX.x) / (greatestX.x - smallestX.x),
                y: 1 - (d.y - minY) / (maxY - minY),
            };
            parsedOriginalData.push(dataPoint);
            parsedOriginalDataNullable.push(dataPoint);
        }
        else {
            const dataPoint = {
                ...d,
                originalX: d.x,
                originalY: d.y,
                x: (d.x - smallestX.x) / (greatestX.x - smallestX.x),
                y: undefined,
            };
            parsedOriginalDataNullable.push(dataPoint);
        }
    }
    return [
        parsedOriginalData,
        parsedOriginalDataNullable,
        {
            greatestX: { x: greatestX.x, y: 0 },
            greatestY,
            smallestX: { x: smallestX.x, y: 0 },
            smallestY,
        },
    ];
};
export function addExtremesIfNeeded(res, data, includeExtremes, removePointsSurroundingExtremes) {
    if (includeExtremes) {
        const { greatestY, smallestY } = findYExtremes(data);
        const [ex1, ex2] = [greatestY, smallestY].sort((a, b) => a.x - b.x);
        let added1 = false;
        let added2 = false;
        const newRes = [];
        for (let i = 0; i < res.length; i++) {
            const d = res[i];
            let justAdded1 = false;
            let justAdded2 = false;
            if (!added1 && (newRes.length === 0 || newRes[newRes.length - 1].x <= ex1.x) && ex1.x <= d.x) {
                justAdded1 = true;
                added1 = true;
                if (ex1.x !== d.x) {
                    if (removePointsSurroundingExtremes) {
                        newRes.pop();
                    }
                    newRes.push(ex1);
                }
            }
            if (!added2 && (newRes.length === 0 || newRes[newRes.length - 1].x <= ex2.x) && ex2.x <= d.x) {
                justAdded2 = true;
                added2 = true;
                if (ex2.x !== d.x) {
                    if (!justAdded1 && removePointsSurroundingExtremes) {
                        newRes.pop();
                    }
                    newRes.push(ex2);
                }
            }
            if ((!justAdded1 && !justAdded2) || !removePointsSurroundingExtremes || i === res.length - 1) {
                newRes.push(d);
            }
        }
        if (!added1) {
            newRes.push(ex1);
        }
        if (!added2) {
            newRes.push(ex2);
        }
        return newRes;
    }
    return res;
}
